import { has, isNil } from 'lodash';
import { createSelector } from 'reselect';

const _getOriginalUser = (state) => state.session.currentUser;
const _getImpersonatedUser = (state) => state.session.impersonatedUser;
const _getUsersEntities = (state) => state.entities.users;
const _getOrgsEntities = (state) => state.entities.orgs;

export const getOriginalUser = createSelector(
  [_getOriginalUser, _getUsersEntities],
  (currentUser, users) => {
    if (currentUser && users[currentUser.user]) {
      let userInfo = {
        ...users[currentUser.user],
        token: currentUser.token,
        apiKey: currentUser.apiKey,
      };

      if (has(currentUser, 'org') && !isNil(currentUser.org)) {
        userInfo['org'] = currentUser.org;
      }

      return userInfo;
    }

    return null;
  },
);

export const getImpersonatedUser = createSelector(
  [_getImpersonatedUser, _getUsersEntities],
  (impersonatedUser, users) => {
    if (impersonatedUser && users[impersonatedUser.user]) {
      let userInfo = {
        ...users[impersonatedUser.user],
        token: impersonatedUser.token,
        apiKey: impersonatedUser.apiKey,
      };

      if (has(impersonatedUser, 'org') && !isNil(impersonatedUser.org)) {
        userInfo['org'] = impersonatedUser.org;
      }
      return userInfo;
    }

    return null;
  },
);

export const getCurrentUser = createSelector(
  [getOriginalUser, getImpersonatedUser],
  (originalUser, impersonatedUser) => {
    // return impersonatedUser if one exists; else, return currentUser
    if (originalUser && impersonatedUser) {
      return impersonatedUser;
    }

    return originalUser;
  },
);

export const getCurrentOrg = createSelector(
  [getCurrentUser, _getOrgsEntities, _getUsersEntities],
  (currentUser, orgs, users) => {
    if (currentUser?.org) {
      let o = orgs[currentUser.org];
      o.ownerUser = users[o.owner];
      return o;
    } else if (currentUser?.default_org && has(orgs, currentUser.default_org)) {
      let o = orgs[currentUser.default_org];
      o.ownerUser = users[o.owner];
      return o;
    } else {
      return null;
    }
  },
);

export const getAccessToken = createSelector([getCurrentUser], (currentUser) => {
  return currentUser ? currentUser.token : null;
});

export const getOriginalAccessToken = createSelector([getOriginalUser], (originalUser) => {
  return originalUser ? originalUser.token : null;
});
